import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppGroup, patchAppGroup } from "../../slices/accessManagerSlice";
import EditableTable from '../../components/EditableTable';
import Pagination from '../../components/Pagination';
import Loader from '../../components/Loader';
import Modal from "../../components/Modal";
import ChangeLog from "../../components/ChangeLog";

const AppGroup = () => {
  const dispatch = useDispatch();
  const { appGroup, status, error } = useSelector((state) => state.accessManager);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(appGroup?.result) ? appGroup?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(appGroup?.result) ? Math.ceil(appGroup?.result?.length / itemsPerPage) : 0;
  const headers = appGroup?.result?.length > 0 ? Object.keys(appGroup.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','active']; // Define editable fields

  const [currentLog,setCurrentLog] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleLog = (id)=>{
    const logData = appGroup?.Change_Log?.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  useEffect(() => {
    dispatch(fetchAppGroup());
  }, [dispatch]);

  if (status === "loading") {
    return (
      <div className="pt-12">
        <Loader />
      </div>
    );
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = appGroup.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, ...editableData } = editedData;
    const updatedData = { id, ...editableData };
    const resp = await dispatch(patchAppGroup(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchAppGroup());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };




  return (
    <div className="w-full flex items-center flex-col">

      <div className="max-w-full">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        />
        </div>

     

<div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>
</div>

<Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
};

export default AppGroup;
